<div class="modal-container">
  <div class="modal-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    <h5 style="margin-left: 8px;">Edit Referral</h5>
    <button mat-icon-button mat-dialog-close aria-label="Close dialog" style="background-color: rgba(0, 0, 0, 0);" class="custom-mat-field">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Debts"> 
            <div class="tab-scroll-content">
                <form [formGroup]="formlyForm">
                    <formly-form 
                    [form]="formlyForm" 
                    [fields]="formlyFields" 
                    [model]="data"></formly-form>
                </form>
            </div>
        </mat-tab>
        <mat-tab label="Loan Calculator"> 
            <div class="tab-scroll-content">
                <div *ngIf="isSahaCalculator; else noSaha">                  
                    <button style="margin-left: 15px; margin-bottom: 8px;" mat-raised-button color="primary" *ngIf="showRefresh" (click)="verifyWaiveOff()">Refresh</button>
                    <app-loancalculator/> 
                </div>
                <ng-template #noSaha>
                    <app-old-loan-calculator/>
                </ng-template>
            </div>
        </mat-tab>
    </mat-tab-group>
  </div>
</div>